<div class="container-fluid webView" style="background: rgb(248, 248, 248) !important; border-radius: 25px;">
    <div class="row">
        <!-- Header -->
        <div class="col-md-12 col-12 col-sm-12 pad0 bgWhite padHeder" style="padding-bottom: 0px; border-radius: 25px; display: flex; align-items: center;">
            <div class="col-md-4 col-12 col-sm-12" style="display: inline-block; padding: 0px;">
                <span class="Mobi" style="font-size: 22px; margin-right: 10px;" class="mobView"><i class="fa fa-chevron-left"></i></span>
                <div style="display: flex; flex-direction: column;">
                    <span style="color: #777; font-size: 14px;">{{prTypeID == 1 ? 'WIP No.' : 'Project'}}</span>
                    <h4 style="display: inline-block;font-size: 1.4rem;">{{jobDetails[0].JobNo}}</h4>  
                </div>
            </div>

            <div  class="col-md-8 col-2 col-sm-12 inLneBlk padHeder" style="padding: 0px; display: inline-block; text-align: right;" data-dismiss="modal">
            
                <!-- <div *ngIf="this.jobItems.length == 0" (click)="openItemSelect(selectItem)" 
                    class="btn-darkBlue brdrRadius3 inLneBlk" style="padding: 4px 14px 4px; font-size: 13px;"> 
                    <i class="zmdi zmdi-plus"></i> Issue Material
                </div> -->

                <div *ngIf="!showMtlConsExpanded" class="inLneBlk" style="margin-right: 10px;"> 
                    <app-material-consumption [prTypeID] = 'prTypeID' (onMtlConsChange)="processEventFromMtlCons($event)"></app-material-consumption>
                </div>

                <div *ngIf="prTypeID == 1 && isShown && jobDetails[0].StatusID == 1" (click)="jobCompleteSave()"   class="btn-orange inLneBlk brdrRadius3" style="margin-right: 10px; padding: 4px 14px 4px; font-size: 13px;"> 
                    <i class="zmdi zmdi-check"></i> Mark Job Done
                </div>


                <div *ngIf="prTypeID == 2"  (click)="jobCompleteSave()"  class="btn-orange inLneBlk brdrRadius3" style="margin-right: 10px; padding: 4px 14px 4px; font-size: 13px;"> 
                    <i class="zmdi zmdi-check"></i> Mark Project Done
                </div>

                <span class="lableBtnGray inLneBlk brdrRadius3" (click)="DeleteItem(wip)" title="Delete" *ngIf="jobDetails[0].StatusID == 1"
                    style="margin-right: 10px; padding: 3px 11px !important;">
                    <i class="fa fa-trash-o" aria-hidden="true"></i>
                </span>
                
                <i class="closeMdl zmdi zmdi-close" style="top: -7px; left: 0px; padding: 8px  12px !important;" (click)="close()"></i>
        
                
            </div>

        </div>

        <div class="{{showMtlConsExpanded ? 'col-md-6' : 'col-md-12'}} col-12 col-sm-12" style="margin-top: 10px; padding-right: 8px;">
            <div class="col-md-12 col-sm-12 col-12 " style="border: 1px solid #15304a; padding: 0px; border-radius: 3px; max-height: 270px; background-color: white;">        
                <!-- Basic Data -->
                <div class="col-md-12 col-12 col-sm-12" style="padding-top: 10px; padding-left: 10px; padding-right: 10px; margin-top: 0px; margin-bottom: 0px;">
                        <span style="font-size: 17px; color: #15304a;">{{prTypeID == 1 ? 'Production Target' : 'Project Summary'}}</span>
                        <div *ngIf="prTypeID == 1 && jobDetails[0].StatusID != 2" class="btn btn-darkBlue brdrRadius3" (click)="openTransaction(8)" style="padding: 4px 14px 4px; font-size: 13px; line-height: 1.66em; float: right;"> <i class="fa fa-sign-in" aria-hidden="true"></i> Receive Finished Goods</div>
                    <div>
                        <div style="margin-top: 10px;">
                            <span *ngIf="orderNo != ''" class="label darkBlueBadge darkBlueBrdr brdrRadius3 bgwhite" style="margin-right: 10px; margin-bottom: 10px; font-size: 12px; padding: 4px 10px;">
                                Order No. <span style="font-size: 12px; font-weight: 600;"> {{orderNo}}</span>
                            </span>

                            <!-- remove wip -->
                            <span class="orangeBadge brdrRadius3 bgwhite orangeBrdr" style="display: none; margin-right: 10px; margin-bottom: 10px; font-size: 12px; padding: 4px 10px;">
                                WIP <span style="font-size: 12px; font-weight: 600;"> {{jobDetails[0]?.JobNo}}</span>
                            </span>

                            <!--change date-->
                            <span *ngIf="isDateLableShow" class="label darkBlueBadge darkBlueBrdr brdrRadius3 bgwhite" style="margin-right: 10px; margin-bottom: 10px; font-size: 12px; padding: 4px 10px;">
                                Due Date <span  *ngIf="isDateLableShow" style="font-size: 12px; font-weight: 600;"> {{jobDetails[0]?.TargetDT | todayTommorow}}</span>
                                 <span *ngIf="!isShown" (click)="editDate(jobDetails[0]?.TargetDT)" style="margin-left: 10px; cursor: pointer;"><i class="fa fa-pencil"></i></span>
                            </span>

                            <span *ngIf="!isDateLableShow" class="label darkBlueBadge darkBlueBrdr brdrRadius3 bgwhite" style="margin-right: 10px; margin-bottom: 10px; font-size: 12px; padding: 4px 10px;"> 
                                <input readonly [(ngModel)]="jobDetails[0].TargetDT" [matDatepicker]="picker" [min]="minDate" (click)="picker.open()"
                                 class="form-control fn13"  tabindex="1"style="display: inline-block; width: 75px; height:18px ; background: #FFF; cursor: pointer;">
                                <mat-datepicker-toggle  matSuffix [for]="picker"
                                style="display: none; position: relative; top: 5px;"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                                <span (click)="saveNewDate()" style="margin-left: 10px; cursor: pointer;"><i class="fa fa-check"></i></span>
                            </span> 
                            
                            <!--change date-->
                            <span *ngIf="jobDetails[0]?.CstrRelName != ''" class="label darkBlueBadge darkBlueBrdr brdrRadius3 bgwhite" style="margin-right: 10px; margin-bottom: 10px; font-size: 12px; padding: 4px 10px;" >
                                Customer <span span style="font-size: 12px; font-weight: 600;">{{jobDetails[0]?.CstrRelName}}</span>
                            </span>
                            
                            <span *ngIf="jobDetails[0]?.Attachment != ''" (click)="viewFile()" class="label darkBlueBadge darkBlueBrdr brdrRadius3 bgwhite" style="margin-right: 10px; margin-bottom: 10px; font-size: 12px; padding: 4px 10px; cursor: pointer;" >
                                <i class="fa fa-file" style="margin-right: 5px;"></i> Descriptor File
                            </span>

                            <span *ngIf="jobDetails[0]?.Stage != ''" class="label darkBlueBadge darkBlueBrdr brdrRadius3 bgwhite" (click)="prTypeID == 1 ? moveJobModal() : ''" style="margin-right: 10px; margin-bottom: 10px; font-size: 12px; padding: 4px 10px; cursor: pointer;" >
                                Stage <span style="font-size: 12px; font-weight: 600;">{{jobDetails[0]?.Stage}}</span>
                            </span>

                            <!-- project item -->
                            <span *ngIf="prTypeID == 2 && productItems.length > 0 && productItems[0]?.ItemName" class="label darkBlueBadge darkBlueBrdr brdrRadius3 bgwhite" style="margin-right: 10px; margin-bottom: 10px; font-size: 12px; padding: 4px 10px;" >
                                Project Type <span style="font-size: 12px; font-weight: 600;">{{productItems[0]?.ItemName}}</span>
                            </span>

                            <!-- <span title="{{jobDetails[0]?.Instructions}}" *ngIf="jobDetails[0]?.Instructions != ''" class="label darkBlueBadge darkBlueBrdr brdrRadius3 bgwhite" style="margin-right: 10px; margin-bottom: 5px; font-size: 12px; padding: 4px 10px;  white-space: nowrap; width: 100%; overflow: hidden; text-overflow: ellipsis;" >
                               {{jobDetails[0]?.Instructions}}
                            </span> -->
                            <div class="brdrRadius3" *ngIf="jobDetails[0]?.Instructions != ''" style="margin-top: 0px; margin-bottom: 10px; background-color: #9eb6be26; color: #212529; font-size: 12px; padding: 10px 10px;">
                                <div style="font-weight: bold; margin-bottom: 2px;">Project Instruction</div>    
                                <div style="color: #777;">{{jobDetails[0]?.Instructions}}</div>
                            </div>

                            <!-- <span class="darkBlueBadge" style="margin-left: 5px; margin-bottom: 10px;">
                                Source <span style="font-size: 18px; font-weight: 600;"> {{productDetials.sorce}}</span>
                            </span> -->
                        </div> 
                        <!-- <div *ngIf="jobDetails[0].Instructions" style="padding-left: 5px; margin-top: 10px; color: #777;">
                            <i class="fa fa-circle" aria-hidden="true" style="font-size: 11px;"></i> {{jobDetails[0]?.Instructions}}
                        </div> -->
                        
                    </div>
                </div>

                

                <!-- Production Target -->
                <div class="col-md-12 col-12 col-sm-12" style="padding-top: 0px; 
                    padding-bottom: 10px; padding-right: 0px; padding-left: 0px;">
                    <!-- <div style="color: #DAA520; font-size: 19px;">
                        <span style="float: right; font-size: 20px; cursor: pointer;" class="webView">
                            <i class="zmdi zmdi-arrow-right-top"></i>
                        </span>
                        <span style="float: right; font-size: 20px; cursor: pointer;" class="mobView" >
                            <i class="zmdi zmdi-arrow-right-top"></i>
                        </span>
                    </div> -->
                    <div style="padding: 0px 10px 0px; max-height: {{jobDetails[0]?.Instructions != '' ? '100px' : '150px' }};  overflow-y: auto; overflow-x: auto;">

                        <!-- Converted Table -->
                        <table class="table table-bordered ngTable brdrRadius3 table-bordered"
                        style="width: 100%; margin-bottom: 10px;  background-color: white;" *ngIf="prTypeID == 1">
                        <thead style="font-size: 13px; cursor: pointer;">
                            <tr>
                                <th style="width: 30%; padding: 5px;">Item Name (Code)</th>
                                <th style="width: 18%; text-align: right; padding: 5px;">Planned</th>
                                <th style="width: 15%; text-align: right; padding: 5px;">Rejected</th>
                                <th style="width: 15%; text-align: right; padding: 5px;">Done</th>
                                <th style="width: 12%; text-align: right; padding: 5px;">WIP</th>
                                <th style="width: 5%; text-align: left;padding: 5px; ">Unit</th>
                                <!-- <th style="width: 40%; text-align: left;padding: 10px;">Status</th> -->
                                <th *ngIf="productItems.length > 1" style="width: 5%; text-align: right;padding: 5px;"></th>
                               
                            </tr>
                        </thead>

                        <tbody>
                            <tr *ngFor="let i of productItems; let ind = index" style="vertical-align: middle;cursor: pointer;font-size: 13px; ">
                                <td style="padding: 5px; vertical-align: middle;">
                                    <div style="display: inline-block; font-size: 13px; padding-bottom:{{prTypeID == 2 ? '8px' : ''}};">
                                        <span> {{i.ItemName}} </span>
                                         <span style="color: #999; font-size: 12px;margin-left: 3px;">({{i.ItemCode}})</span>
                                        </div>
                                </td>
                                <td style="text-align: right; vertical-align: middle; padding:0px 3px;">
                                    <span *ngIf="prTypeID == 1 && !i.IsSelect" style="margin-right: 5px; font-size: 13px;"> {{i.PlanQty}}</span>   

                                            <input type="text" id="txtItem" [(ngModel)]="i.PlanQty" class="form-control"
                                            tabindex="1" placeholder="Qty" 
                                            style="height: 20px; width: 40px; display: inline-block; background: inherit;"
                                            maxlength="50" *ngIf="i.IsSelect"/>
                                       
                                    <span  style="border-radius: 10px; color: #e88421; cursor: pointer;" title="Edit" *ngIf="!i.IsSelect;" (click)="editQty(i)"><i class="fa fa-pencil" ></i></span>
                                    <span  style="margin-right: 3px;  color: #4caf50; cursor: pointer;" *ngIf="i.IsSelect" (click)="save()" ><i class="fa fa-check"></i></span>
                                    <span  style=" color: gray; cursor: pointer; padding-left: 0px;" *ngIf="i.IsSelect" (click)="cancel(i)" ><i class="fa fa-times"></i></span>
                                
                                </td>
                                <td style="text-align: right;vertical-align: middle;padding: 5px;">{{i.RejQty ? i.RejQty:'0'}}</td>
                                <td style="text-align: right;vertical-align: middle;padding: 5px;">{{i.GenQty ? i.GenQty:'0'}}</td>
                                <td style="text-align: right;vertical-align: middle;padding: 5px;">{{i.TempPlanQty - (i.GenQty  + i.RejQty ) ? i.TempPlanQty - (i.GenQty  + i.RejQty ):'0'}}</td>
                                <td style="text-align: left;vertical-align: middle;padding: 5px;">{{i.SKU}}</td>

                                
                                 <!-- status of WIP d-none -->
                                 <td style="text-align: left;vertical-align: middle;padding: 5px 0px; padding: 5px;display: none;">
                                    <div *ngIf="prTypeID == 1" style="font-size: 15px; color: #777; ">
                                        <div style="display: inline-block; width: 100%; ">
                                            <!-- <span class="orangeBadge brdrRadius3 bgwhite orangeBrdr" style="font-size: 10px;margin-right: 3px; padding: 4px;" *ngIf="i.TempPlanQty > 0">
                                                Plan {{i.TempPlanQty}} 
                                            </span> -->
                                            <span class="orangeBadge brdrRadius3 bgwhite orangeBrdr" style="font-size: 10px;margin-right: 3px; padding: 4px;" *ngIf="i.RejQty > 0">
                                                Rej. {{i.RejQty}} 
                                            </span>
                                            <span class="orangeBadge brdrRadius3 bgwhite orangeBrdr" style="font-size: 10px;margin-right: 3px; padding: 4px;" *ngIf="i.GenQty > 0">
                                                Done {{i.GenQty}} 
                                            </span>
                                            <span class="orangeBadge brdrRadius3 bgwhite orangeBrdr" style="font-size: 10px;margin-right: 3px; padding: 4px;" *ngIf="(i.TempPlanQty - (i.GenQty  + i.RejQty )) > 0">
                                                WIP {{i.TempPlanQty - (i.GenQty  + i.RejQty )}} <span>{{i.unit}}</span>
                                            </span>
        
                                        </div>
                                    </div>
                                        </td>

                                  <td style="vertical-align: inherit;padding: 5px;" *ngIf="productItems.length > 1">
                                    <span  *ngIf="productItems.length > 1" style="color: gray; cursor: pointer;" (click)="deleteJobsItems(ind)"><i class="fa fa-trash-o"></i></span>
                                  </td>
                               
                            </tr>
                       
                        </tbody>
                    </table>
                    <!-- Table End -->

                    <!-- Old list View - d-none -->
                    <div style="display: none;" *ngIf="prTypeID == 2">
                        <div *ngFor="let i of productItems; let ind = index" class="brdrRadius3" style="padding: 10px 15px; margin-bottom: 15px; background: #e8842108;">
                            <div style="font-size: 13px;">
                                <div style="display: inline-block; font-size: 13px;">
                                <span> {{i.ItemName}} </span>
                                 <span style="color: #999; font-size: 12px;margin-left: 3px;">({{i.ItemCode}})</span>
                                </div>
                                <div *ngIf="prTypeID == 1"style="display: none; width: 40%; text-align: right;">
                                    <span *ngIf="prTypeID == 1 && !i.IsSelect" style="margin-right: 5px; font-size: 13px;"> {{i.PlanQty}}</span>   
                                        <span *ngIf="i.IsSelect">

                                            <input type="text" id="txtItem" [(ngModel)]="i.PlanQty" class="form-control"
                                            tabindex="1" placeholder="Qty" 
                                            style="height: 20px; padding: 13px;width: 80px; display: inline-block; background: inherit; text-align: right;"
                                            maxlength="50" />
                                        </span>
                                        <span>{{i.SKU}}</span>
                                        <span  *ngIf="productItems.length > 1" style="padding: 2px 7px 2px; border-radius: 10px; color: gray; cursor: pointer;" (click)="deleteJobsItems(ind)"><i class="fa fa-trash-o"></i></span>
                                        <span  style="padding: 2px 7px 2px; border-radius: 10px; color: #e88421; cursor: pointer;" title="Edit" *ngIf="!i.IsSelect;" (click)="editQty(i)"><i class="fa fa-pencil" ></i></span>
                                        <span  style="padding: 2px 7px 2px; border-radius: 10px; color: #4caf50; cursor: pointer;" *ngIf="i.IsSelect" (click)="save()" ><i class="fa fa-check"></i></span>
                                        <span  style="padding: 2px 7px 2px; border-radius: 10px; color: gray; cursor: pointer; padding-left: 0px;" *ngIf="i.IsSelect" (click)="cancel(i)" ><i class="fa fa-times"></i></span>
                                    
                                </div>  
                            </div>

                            <!-- status of WIP -->
                            <div *ngIf="prTypeID == 1" style="margin-top: 5px; font-size: 15px; color: #777; padding-bottom: 10px; display: none;">
                                <div style="display: inline-block; width: 100%; margin-left: -5px;">
                                    <span class="orangeBadge brdrRadius3" style="margin-right: 10px; font-size: 12px; padding: 6px 15px;" *ngIf="i.TempPlanQty > 0">
                                        Plan {{i.TempPlanQty}} 
                                        <!-- <span>{{i.SKU}}</span> -->
                                    </span>
                                    <span class="orangeBadge brdrRadius3" style="margin-right: 10px; font-size: 12px; padding: 6px 15px;" *ngIf="i.RejQty > 0">
                                        Rej. {{i.RejQty}} 
                                        <!-- <span>{{i.SKU}}</span> -->
                                    </span>
                                    <span class="orangeBadge brdrRadius3" style="margin-right: 10px; font-size: 12px; padding: 6px 15px;" *ngIf="i.GenQty > 0">
                                        Done {{i.GenQty}} 
                                        <!-- <span>{{i.SKU}}</span> -->
                                    </span>
                                    <span class="orangeBadge brdrRadius3" style="font-size: 12px; padding: 6px 15px;" *ngIf="(i.TempPlanQty - (i.GenQty  + i.RejQty )) > 0">
                                        WIP {{i.TempPlanQty - (i.GenQty  + i.RejQty )}} <span>{{i.unit}}</span>
                                    </span>

                                </div>
                            </div>
                        </div> 
                    </div>

                    <!-- Expence Add and Show -->
                    <div *ngIf="prTypeID == 2" style="color: #777;">
                        <div style="display: inline-block; width: 100%;">
                            <span title="{{costSum != 0 ? 'View Expenses' : ''}}" (click)="costSum != 0 ? costTypeListMdl(productItems) : ''" class="btn-darkBlue brdrRadius3 {{costSum == 0  ? 'whiteBtn' : ''}}" style="cursor:pointer; padding: 4px 10px; margin-right: 10px; font-size: 12px; line-height: 20px;" >
                                Total Expenses <span style="margin-right:5px; font-weight: 600;">₹ {{costSum  | lacFormat : 1}}</span>
                            </span>
                            <span *ngIf="prTypeID == 2 && rights.prdCfg && rights.allPrd" class="btn-darkBlue brdrRadius3" title="Enter Expense" (click)="costTypeEntryMDl(productItems)" style="cursor:pointer; padding: 4px 10px; margin-right: 10px; font-size: 12px; line-height: 20px;">
                                <i class="zmdi zmdi-plus" style="margin-right:5px"></i>Enter Expense
                            </span>
                            <span *ngIf="prTypeID == 2 && rights.prdCfg && rights.allPrd" class="btn-darkBlue brdrRadius3" title="Update Access" (click)="openUserAccessModal(mdlUserAccess)" style="cursor:pointer; padding: 4px 10px; margin-right: 10px; font-size: 12px; line-height: 20px;">
                                <i class="fa fa-pencil" style="margin-right:5px"></i>Update Access
                            </span>
                        </div>
                    </div>
                       
                    </div>
                </div>

            </div>
            <div style="background-color: #fff; width: 100%; height: {{showMtlConsExpanded ? '260px' : 'auto'}};  overflow: hidden;
            padding: 0px; margin-top: 10px; border-radius: 3px; border: 1px solid darkgreen; display: inline-block; margin-right: 15px;">
                <app-process-stages></app-process-stages>
            </div>
        </div>

    
        <div *ngIf="showMtlConsExpanded" class="col-md-6 col-12 col-sm-12" style="padding-left: 5px">
            <!-- BOM -->
            <div class="col-md-12 col-12 col-sm-12" 
                style="background-color: #fff; padding-top: 10px; height: 527px; overflow: hidden; scroll-padding-top:10px; margin-bottom: 10px;
                padding-bottom: 10px; margin-top: 10px; border-radius: 3px; border: 1px solid #e88421; display: inline-block; padding: 5px; padding-top: 10px;">
                <app-material-consumption [prTypeID] = 'prTypeID'></app-material-consumption>
            </div>
        </div>
    </div>
</div>


<div class="container-fluid padMob mobView">
    <div class="row">
        <!-- Header -->
        <div class="col-md-12 col-12 col-sm-12 pad0 bgWhite padHeder" style="padding-bottom: 0px; border-radius: 25px;">
            <span class="Mobi" style="font-size: 22px; margin-right: 10px;" class="mobView">
                <i class="fa fa-chevron-left" (click)="goBack()"></i></span>
            <h4 style="display: inline-block;">{{prTypeID == 1 ? 'Update Production Job' : 'Update Project'}}</h4>  
            <div (click)="jobCompleteSave()" *ngIf="isShown"  class="btn-orange inLneBlk brdrRadius3" style="margin-left: 10px; padding: 8px 11px 6px; position: relative;font-size: 13px;"> 
                <i class="fa fa-check"></i>
            </div> 
            <span class="lableBtnGray inLneBlk" title="Delete" (click)="DeleteItem(wip)" style="padding: 6px 12px; float: right; position: relative;">
                <i class="fa fa-trash-o" aria-hidden="true"></i>
            </span>
        </div>

        <div class="col-md-6 col-sm-12 col-12 headerPadding">      
              
            <!-- Basic Data -->
            <!-- <div class="col-md-12 col-12 col-sm-12" style="padding-top: 10px; margin-top: 10px; 
                padding-left: 10px; margin-bottom: 5px; background-color: #e8842108;">
                <div>
                    <div style="margin-top: 8px;">
                        <span class="yellowBadge" style="margin-left: 5px; margin-bottom: 10px;">
                            WIP <span style="font-size: 18px; font-weight: 600;">{{jobDetails[0]?.JobNo}}</span>
                        </span>

                        <span class="greenBadge" style="margin-left: 5px; margin-bottom: 10px;">
                            Due Date <span style="font-size: 18px; font-weight: 600;">{{jobDetails[0]?.TargetDT | date: 'dd-MMM-yy'}}</span>
                        </span>
                        
                        <span class="orangeBadge" style="margin-left: 5px; margin-bottom: 10px;">
                            <span>{{jobDetails.customerName}}</span>
                        </span>

                        <span class="tealBadge" style="margin-left: 5px; margin-bottom: 10px;">
                            Stage <span style="font-size: 18px; font-weight: 600;">{{jobDetails?.stageName}}</span>
                        </span>
            
                        <span class="darkBlueBadge" style="margin-left: 5px; margin-bottom: 10px;">
                            Source <span style="font-size: 18px; font-weight: 600;"> {{productDetials.sorce}}</span>
                        </span> 
                    </div> 
                </div>
            </div> -->

            <!-- Production Target -->
            <div class="col-md-12 col-12 col-sm-12" style="background-color: #E8842108; padding-top: 10px; 
            padding-bottom: 10px; margin-top: 10px;" (click)="mobProductTarget(jobDetails, productItems)">
                <div style="color: #E88421; font-size: 19px;">
                    <span>{{prTypeID == 1 ? 'Production Target' : 'Project Target'}}</span>
                    <span style="float: right; font-size: 20px; cursor: pointer;" class="webView">
                        <i class="zmdi zmdi-arrow-right-top"></i>
                    </span>
                    <span style="float: right; font-size: 19px !important; cursor: pointer;" class="mobView">
                        <i class="zmdi zmdi-arrow-right-top"></i>
                    </span>
                </div>
                <div>
                    <!-- <div *ngFor="let i of jobDetails.products" style="padding-left: 10px; margin-top: 8px;">
                        <div style="margin-top: 5px; font-size: 15px; color: #777;">
                            <div style="display: inline-block; width: 80%; font-size: 15px; color: #777;">
                                {{i.productName}}
                            </div>
                            <div style="display: inline-block; width: 19%; text-align: right;">
                                {{i.launch}} <span>{{i.unit}}</span>
                            </div>
                        </div>
                        <div style="margin-top: 5px; font-size: 15px; color: #777;">
                            <div style="display: inline-block; width: 100%;">
                                <span class="orangeBadgeNew" style="margin-right: 10px;" *ngIf="i.rejQty > 0">
                                    Rej. {{i.rejQty}} <span>{{i.unit}}</span>
                                </span>
                                <span class="greenBadgeNew" style="margin-right: 10px;" *ngIf="i.done > 0">
                                    Done {{i.done}} <span>{{i.unit}}</span>
                                </span>
                                <span class="yellowBadgeNew" *ngIf="(i.launch - (i.done  + i.rejQty )) > 0">
                                    WIP {{i.launch - (i.done  + i.rejQty )}} <span>{{i.unit}}</span>
                                </span>
                            </div>
                        </div>
                    </div> -->
                </div>
            </div>

            <!-- Material Consumption -->
            <div class="col-md-12 col-12 col-sm-12" style="background-color: #E8842108; padding-top: 10px; 
            padding-bottom: 10px; margin-top: 10px;" (click)="mobMaterialCons()">
                <div style="color: #e88421; font-size: 19px;">
                    <span>Material Consumption</span>
                    <span style="float: right; font-size: 20px; cursor: pointer;" class="webView">
                        <i class="zmdi zmdi-plus"></i>
                    </span>

                    <span style="float: right; font-size: 19px !important;cursor: pointer;" class="mobView">
                        <i class="zmdi zmdi-plus"></i>
                    </span>

                </div>            
            </div>

            <!-- Byproducts & Scrap -->
            <!-- <div class="col-md-12 col-12 col-sm-12 tealBckNew" style="padding-top: 10px; 
            padding-bottom: 10px; margin-top: 10px;">
                <div style="font-size: 19px;">
                    <span>Byproduct Generation</span>
                    <span style="float: right; font-size: 20px; cursor: pointer;" class="webView">
                        <i class="zmdi zmdi-plus"></i>
                    </span>
                    <span style="float: right; font-size: 20px; cursor: pointer;" class="mobView">
                        <i class="zmdi zmdi-plus"></i>
                    </span>
                </div>            
            </div> -->

            <!-- Process Stages -->
            <div class="col-md-12 col-12 col-sm-12" style="background-color: #E8842108; padding-top: 10px; 
            padding-bottom: 10px; margin-top: 10px;" (click)="mobProcessStages()">
                <div style="color: #E88421; font-size: 19px;">
                    <span>Process Stages</span>
                    <span style="float: right; font-size: 20px; cursor: pointer;" class="webView">
                        <i class="zmdi zmdi-arrow-right-top"></i>
                    </span>
                    <span style="float: right;font-size: 19px !important;cursor: pointer;" class="mobView">
                        <i class="zmdi zmdi-arrow-right-top"></i>
                    </span>
                </div>            
            </div>

            <!-- Rejection Entry -->
            <!-- <div class="col-md-12 col-12 col-sm-12 darkBlueBckNew" style="padding-top: 10px; 
            padding-bottom: 10px; margin-top: 10px;">
                <div style="font-size: 19px;">
                    <span>Rejection</span>
                    <span style="float: right; font-size: 20px; cursor: pointer;" class="webView">
                        <i class="zmdi zmdi-arrow-right-top"></i>
                    </span>
                    <span style="float: right; font-size: 20px; cursor: pointer;" class="mobView">
                        <i class="zmdi zmdi-arrow-right-top"></i>
                    </span>
                </div>            
            </div> -->
        </div>
    </div>
</div>

<!-- Conclusion Notes Entry Modal -->
<ng-template #mdlUserAccess let-modal>
    <div class="modal-header" style="border-bottom: none; padding: 15px 15px 5px;">
        <div class="col-md-12 col-12 col-xs-12">
            <div class="row">
                <div class="col-md-9 col-10 col-xs-10" style="padding-left: 0px;" tabindex="1">
                    <h4 class="modal-title">
                        <span id="ApntmntHdr">Update User Access</span>
                    </h4>
                </div>
                <div class="col-md-3 col-2 col-xs-2" style="padding: 0px;" (click)="closeUserAccessModal()">
                    <i class="closeMdl zmdi zmdi-close" style="float: right;" ></i>
                </div>
            </div>
        </div>
    </div>

    <!--Body-->
    <div class="modal-body" style="padding-top: 0px; padding-bottom: 0px;">
        <!-- Select users -->
        <div *ngIf="prTypeID == 2" class="col-md-12 col-12 col-xs-12 pad0" style="margin-top: 0px;font-size: 13px !important;">
            <div class="label-new">Users</div>
            <div style="display: flex; gap: 10px; margin-bottom: 10px;" >
                <select class="form-control fn13 bzInput" style="cursor: pointer; padding: 0; background-color: white !important;" [(ngModel)]="selectedUserID" (change)="selectUser()" >
                    <option value="0">Select Executive</option>
                    <ng-container *ngFor="let u of userList">
                        <option *ngIf="!u.selected" value="{{u.UserID}}">{{ u.Name }}</option>
                    </ng-container>
                </select>
            </div>
            <div *ngIf="users.length > 0" style="margin-bottom: 10px; display: flex; flex-wrap: wrap; gap: 10px; max-height: 350px;">
                <div *ngFor="let user of users; let i = index;" style="display: inline-block; border: 1px solid #DDD; padding: 5px 7px; border-radius: 3px; color: #333; background: #fff; font-size: 13px; height: 30px !important;">
                    <div style="padding: 0px; margin-left: 5px; display: inline-block;">{{user.Name}}</div>
                    <span title="Remove User" (click)="removeUser(i)" style="font-size: 12px; cursor: pointer; margin-left: 10px; margin-right: 5px; cursor: pointer;">
                        <i class="zmdi zmdi-close"></i>
                    </span>
                </div>
            </div>
        </div>
    </div>
    <!-- WebView Footer -->
    <div class="modal-footer" style="border: none; text-align: left; float: left; justify-content: left !important; padding: 0px 15px 15px;">
        <span class="btn btn-darkGreen brdrRadius3" (click)="updateUserAccess()" style="font-size: 13px; padding: 2px 7px 2px; line-height: 1.66em;">
            <i class="fa fa-check" style="margin-right: 5px;"></i>
            <span>Save</span>
        </span>
    </div>
</ng-template>

<!-- <app-en-output (newItemEvent)="addItem($event)"></app-item-output> -->
<!-- <app-enter-expense (newItemEvent)="addItem($event)"></app-enter-expense> -->